module.exports = __webpack_public_path__ + "static/media/olivier award.4a4265c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/olivier award.jpg
// module id = 288
// module chunks = 0